var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.164062,
    y: 0.0715332,
    width: 80,
    height: 80,
    rx: 24,
    fill: "#EEEEFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1312 26.7383C32.7829 26.7383 30.6087 26.7383 29.0989 27.8021C28.6663 28.1069 28.2822 28.4683 27.9584 28.8755C26.8281 30.2965 26.8281 32.3428 26.8281 36.4353V39.8292C26.8281 43.7801 26.8281 45.7555 27.4534 47.3332C28.4585 49.8697 30.5843 51.8704 33.2793 52.8164C34.9556 53.4049 37.0545 53.4049 41.2524 53.4049C43.6512 53.4049 44.8505 53.4049 45.8084 53.0687C47.3484 52.5281 48.5631 51.3848 49.1375 49.9355C49.4948 49.0339 49.4948 47.9051 49.4948 45.6473V44.7383",
    stroke: "#3F3DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1641 34.0715C44.1641 34.0715 44.8307 34.0715 45.4974 35.4048C45.4974 35.4048 47.615 32.0715 49.4974 31.4048",
    stroke: "#3F3DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4974 33.4049C53.4974 37.0868 50.5126 40.0716 46.8307 40.0716C43.1489 40.0716 40.1641 37.0868 40.1641 33.4049C40.1641 29.7231 43.1489 26.7383 46.8307 26.7383C50.5126 26.7383 53.4974 29.7231 53.4974 33.4049Z",
    stroke: "#3F3DA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8281 40.0715C26.8281 42.5261 28.818 44.5159 31.2726 44.5159C32.1603 44.5159 33.2068 44.3605 34.07 44.5917C34.8368 44.7971 35.4358 45.3962 35.6413 46.163C35.8726 47.0262 35.717 48.0727 35.717 48.9605C35.717 51.415 37.7069 53.4049 40.1615 53.4049",
    stroke: "#3F3DA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.f33c6c87d74926588214646d60f981bb.svg";
export { ForwardRef as ReactComponent };